var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-card',{attrs:{"height":"400","color":"transparent","flat":""}},[_c('div',{staticClass:"subheading secondary--text"},[_vm._v("\n          "+_vm._s(_vm.$t('payment.do_not_close_the_page'))+"\n        ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }